module.exports = __webpack_public_path__ + "img/logo.1e1dbc77.jpg";